import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { VALIDATORS } from 'app/constants';
import { MEASUREMENT_CALCULATIONS } from 'app/constants/measurement-calculations.data';
import {
  MeasurementCalculations, MeasurementCalculationsGroup, MeasurementCalculationsItem, MeasurementCalculationsItemType
} from 'models/product-configuration.model';
import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-measurement-calculations',
  templateUrl: './measurement-calculations.component.html',
  styleUrls: ['./measurement-calculations.component.scss']
})
export class MeasurementCalculationsComponent implements OnInit {
  readonly MEASUREMENT_CALCULATIONS = MEASUREMENT_CALCULATIONS;

  measurementCalculationsItemType = MeasurementCalculationsItemType;

  form!: UntypedFormGroup;

  formReady = false;

  constructor(
    private fb: UntypedFormBuilder,
    private storeService: StoreService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.setupForm();
  }

  setupForm(): void {
    this.storeService.setFormReady(this.formReady);

    this.form = this.fb.group({});

    this.addFormControls();

    this.formReady = true;
    this.storeService.setFormReady(this.formReady);
  }

  addFormControls(): void {
    const measurementCalculations = this.MEASUREMENT_CALCULATIONS;

    if (!measurementCalculations) {
      return;
    }

    measurementCalculations.forEach((measurement: MeasurementCalculations) => {
      this.form.addControl(measurement.id, this.fb.group({}));

      measurement.groups.flat().forEach((group: MeasurementCalculationsGroup) => {
        group.items.forEach((item: MeasurementCalculationsItem) => {
          if (item.type === MeasurementCalculationsItemType.INPUT) {
            (this.form.controls[measurement.id] as UntypedFormGroup)
              .addControl(item.controlName, this.fb.control('', [
                Validators.min(VALIDATORS.MIN.MEASUREMENT_CALCULATIONS),
                Validators.max(VALIDATORS.MAX.MEASUREMENT_CALCULATIONS)
              ]));
          }
        });
      });
    });
  }

  resetForm(): void {
    this.form.reset();
  }

  getFormControlGroup(measurementCalculationsId: string): UntypedFormGroup {
    return this.form.controls[measurementCalculationsId] as UntypedFormGroup;
  }
}
